<template>
    <div v-if="qrCodeString" class="copy-qrcode">
        <span class="text-break">
            {{ showMore ? qrCodeString : qrCodeString.substring(0, 50) }}
            <a class="show-more" href="#!" @click="toggleShowMore">{{ showMore ? 'Ver menos' : 'Ver tudo' }}</a>
        </span>

        <CopyButton
            :title-string="qrCodeString"
            @click-copy="copyText"
        />
    </div>
</template>

<script>
import CopyButton from '@/components/CopyButton.vue';

export default {
  components: {
    CopyButton
  },
  props: {
    qrCodeString: {
      type: String,
      default: '',
      required: false,
    },

  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },

    copyText() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.qrCodeString);
      }
    }
  },
  data() {
    return {
      showMore: false,
    };
  }
};

</script>

<style lang="scss" scoped>
.copy-qrcode {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
}

.copy-link {
  color: #0774E7;
  cursor: pointer;
  text-decoration: none;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.qrcode-btn {
  display: flex;
  height: 48px;
  padding: 8px 16px;

  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #0774E7;
  background: #FFF;

  @media screen and (max-width: 1024px) {
    width: 100%;
    flex-direction: row;
  }
}

.show-more {
  color: #0774E7;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-decoration-line: underline;
}

.copy-btn {
    @media screen and (max-width: 1024px) {
        width: 100%;
    }
}
</style>
